import { EpimsBaseEntityDto } from './epim-base.dto';
export class PipelineLicenseStageDto extends EpimsBaseEntityDto {

    PipelineLicenseStageId: string;
    StageNo: number;
    TemplateId: string;
    PipelineLicenseStageName: string;
    PipelineLicenseCategoryId: string;
    SubscriptionUserId: string;
    EstimatedDuration: number;
}
